<template>
  <div>
    <current-player-tiles />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { NS_GAME_STATE } from "@/store/constants";
import CurrentPlayerTiles from "@/components/board/CurrentPlayerTiles";

export default {
  name: 'CurrentPlayerSection',

  components: {
    CurrentPlayerTiles
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'localPlayer',
    ])
  },
}
</script>

<style scoped>
</style>

